export const AUTH_PAGE = {
  auth: '/auth'
} as const

export const BASE_PAGE = {
  root: '/',
  all: '*'
} as const

export const REGISTRY_PAGE = {
  registry: '/registry',
  registryId: '/registry/:id',
  registryArchivesId: '/registry/archives/:id'
} as const

export const MONITORING_LAUNCH_PAGE = {
  monitoringLaunch: '/monitoring-launch',
  monitoringLaunchId: '/monitoring-launch/:id' // такого раздела нет
} as const

export const MONITORING_REGISTRY_PAGE = {
  monitoringRegistry: '/monitoring-registry',
  monitoringRegistryId: '/monitoring-registry/:id' // такого раздела нет
} as const

export const CONTRACTOR_SECTION_PAGE = {
  contractorSection: '/contractor-section',
  contractorSectionId: '/contractor-section/:id'
} as const

export const PROCESSING_RESULTS_PAGE = {
  processingResults: '/processing-results',
  productCard: '/processing-results/:id'
} as const

export const TRANSFER_RESULTS_PAGE = {
  transferResults: '/transfer-results'
}

export const QUOTE_REPORT_PAGE = {
  quoteReport: '/quota-report'
} as const

export const INTERNAL_TASKS_PAGE = {
  internalTasks: '/internal-tasks'
} as const

export const EXTERNAL_PRODUCTS_CATALOG_PAGE = {
  externalProductsCatalog: '/external-products-catalog'
} as const

export const SETTINGS_PAGE = {
  monitoringSchedule: '/monitoring-schedule',
  directoryContractors: '/directory-contractors',
  managingSubtypes: '/managing-subtypes',
  managingMonitorings: '/managing-monitorings',
  templatesEditor: '/templates-editor',
  checkingPricesCompetitors: '/checking-prices-competitors',
  classifierControls: '/classifier-controls'
}

export const ERROR_PAGE = '/404'
